import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetConversationListRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetConversationListResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getConversationList = (request: GetConversationListRequest, options?: CashRequestOptions) =>
  post<GetConversationListRequest, GetConversationListResponse>('/2.0/cash/get-conversation-list', request, {
    ...options,
    rejectOnError: true,
  })
